// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"444":"2bb11c2f","445":"b4a7ba67","648":"341c2610","661":"9b40ed17","787":"e8f42ac7"}[chunkId] + ".chunk.js";
};